module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "dataTables_length col-sm-4",
    attrs: {
      "id": "example1_length"
    }
  }, [_c('label', [_vm._v("Show\n                    "), _c('select', {
    staticClass: "form-control input-sm",
    attrs: {
      "name": "example1_length",
      "aria-controls": "example1"
    },
    on: {
      "change": _vm.showSizeChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary new-btn col-sm-offset-1 col-sm-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("New case")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_filter",
    attrs: {
      "id": "example1_filter"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search",
      "placeholder": "Syria",
      "aria-controls": "example1"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "change": _vm.searchChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat btn-primary search-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row filters-row"
  }, [_c('div', {
    staticClass: "col-sm-12 filters"
  }, [_c('div', {
    staticClass: "card card-body"
  }, [_c('tags-search', {
    ref: "tags-search"
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'creationDate'
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('creationDate', 'true')
      }
    }
  }, [_vm._v("Creation Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Platform(s): activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'testimonySize'
    },
    attrs: {
      "aria-label": "Engine version: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('testimonySize', 'true')
      }
    }
  }, [_vm._v("Testimonies size")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Creator")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "Tags",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Tags")])])]), _vm._v(" "), (_vm.cases.length === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("No data found")]) : _c('tbody', _vm._l((_vm.cases), function(currentCase) {
    return _c('tr', {
      staticClass: "even clickable",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.goToCase(currentCase)
        }
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("prettyDateTime")(currentCase.creationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(currentCase.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(currentCase.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(currentCase.testimonySize))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(currentCase.creatorName))]), _vm._v(" "), _c('td', _vm._l((_vm.tagsByCase[currentCase._id]), function(tag) {
      return _c('span', {
        staticClass: "label label-default",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.searchByTag(tag)
          }
        }
      }, [_vm._v(_vm._s(tag))])
    }), 0)])
  }), 0)])])]), _vm._v(" "), (_vm.cases.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "align-infos col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "example1_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("Showing " + _vm._s(_vm.total - _vm.cases.length + 1 > (_vm.page + 1) * _vm.size - 1 ? (_vm.page + 1) * _vm.size - 1 : _vm.total - _vm.cases.length + 1) + " to " + _vm._s(_vm.total > (_vm.page + 1) * _vm.size ? (_vm.page + 1) * _vm.size : _vm.total) + " of " + _vm._s(_vm.total) + " entries")])]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination col-sm-12"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.pageTotal,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.changePage,
      "prev-text": 'Prev',
      "force-page": _vm.page,
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('new-case-modal', {
    attrs: {
      "id": "NewCaseModal"
    },
    on: {
      "create": _vm.createCase
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cases")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e8a2ac3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Cases.vue
// module id = 442
// module chunks = 1